// extracted by mini-css-extract-plugin
var _1 = "Text-module_text_danger__kJuk_W";
var _2 = "Text-module_text_default__SX0DEZ";
var _3 = "Text-module_text_primary__h4aJyD";
var _4 = "Text-module_text_secondary__TDLZtn";
var _5 = "Text-module_text_vox__AzTsC0";
export { _1 as "text_danger", _2 as "text_default", _3 as "text_primary", _4 as "text_secondary", _5 as "text_vox" }
